import { Component, Input }         from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

import { CompanyCountryValidationsModel } from '../../../companies/models/company.country-validations';
import { TextControlComponent }           from '../text-control/text-control.component';

@Component({
  selector   : 'wor-phone-control',
  template: require('./phone-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class PhoneControlComponent extends TextControlComponent {
  @Input() isMobile    = false;
  @Input() maxlength   = 30;
  @Input() validations : CompanyCountryValidationsModel;

  handleModelChange ( _model : string ) : void {
    this.modelChange.emit(_model?.replace(/\D/g,''));
  }
}
